const productItemBody = `
  title
  handle
  vendor
  productType
  availableForSale
  priceRange {
    minVariantPrice {
      amount
      # currencyCode
    }
  }
  images (first: 1) {
    edges {
      node {
        originalSrc
        transformedSrc (maxWidth: $imgMaxW)
        altText
      }
    }
  }
  tags
  variants (first:1) {
    edges {
      node {
        # availableForSale
        # use product.priceRange....
        # priceV2 {
          # amount
        # }
        selectedOptions {
          name
          value
        }
      }
    }
  }
  options {
    name
    values
  }
  metafields (namespace:"bms", first: 10) {
    edges {
      node {
        key
        value
      }
    }
  }
`

const productBody = `
  availableForSale
  title
  handle
  vendor
  productType
  description
  descriptionHtml
  priceRange {
    minVariantPrice {
      amount
      # currencyCode
    }
  }
  images (first:20) {
    edges {
      node {
        altText
        originalSrc
        transformedSrc (maxWidth: $imgMaxW)
        meta: transformedSrc (maxWidth: 1200)
      }
    }
  }
  options {
    name
    values
  }
  variants (first:12) {
    edges {
      node {
        availableForSale
        
        id
        title
        priceV2 {
          amount
        }
        image {
          altText
          originalSrc
          transformedSrc (maxWidth: $imgMaxW)
        }
        selectedOptions {
          name
          value
        }
      }
    }
  }
  collections (first:3) {
    edges {
      node {
        handle
        title
      }
    }
  }
  metafields (namespace:"bms", first: 10) {
    edges {
      node {
        key
        value
      }
    }
  }
`

const checkoutBody = `
  id
  completedAt
  webUrl
  subtotalPriceV2 {
    amount
  }
  totalPriceV2 {
    amount
  }
  lineItems (first:250) {
    edges {
      node {
        id
        quantity
        title
        variant {
          availableForSale
          id
          title
          priceV2 {
            amount
          }
          image {
            altText
            transformedSrc (maxWidth: 885)
          }
        }
      }
    }
  }
  shippingAddress {
    countryCodeV2
  }
`

export const queryProducts = (full = false) => `
  query ($first: Int!, $after: String, $query: String, $imgMaxW: Int, $sortKey: ProductSortKeys, $reverse: Boolean) {
    products (first: $first, query: $query, after: $after, sortKey: $sortKey, reverse: $reverse) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          ${full ? productBody : productItemBody}
        }
      }
    }
  }
`

export const queryProduct = `
  query ($handle: String!, $imgMaxW: Int) {
    productByHandle (handle: $handle) {
      ${productBody}
    }
  }
`

export const queryCheckout = `
  query ($id: ID!) {
    node (id: $id) {
      ...on Checkout {
        ${checkoutBody}
      }
    }
  }
`
export const mutateCreateCheckout = `
  mutation checkoutCreate($input: CheckoutCreateInput!) {
    checkoutCreate(input: $input) {
      checkout {
        ${checkoutBody}
      }
    }
  }
`

export const mutateCheckoutItems = `
  mutation ($id: ID!, $lineItems: [CheckoutLineItemInput!]!) {
    checkoutLineItemsReplace (checkoutId: $id, lineItems: $lineItems) {
      checkout {
        ${checkoutBody}
      }
    }
  }
`

export const queryCollection = `
  query ($handle: String!, $first: Int!, $after: String, $imgMaxW: Int, $sortKey: ProductCollectionSortKeys, $reverse: Boolean) {
    collectionByHandle (handle: $handle) {
      title
      handle
      description
      descriptionHtml
      products (first:$first, after: $after, sortKey: $sortKey, reverse: $reverse) {
        pageInfo {
          hasNextPage
        },
        edges {
          cursor
          node {
            ${productItemBody}
          }
        }
      }
    }
  }
`
